import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.funkprotokoll-vorlagen-liste';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenFunkprotokollVorlagenListeEffects {

    FunkprotokollVorlagenListe$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_FUNKPROTOKOLL_VORLAGEN_LISTE),
        mergeMap((x: ac.GetFunkprotokollVorlagenListeAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getFunkprotokollVorlagenListe().pipe(
                map((result: any) => {
                    return new ac.GetFunkprotokollVorlagenListeErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetFunkprotokollVorlagenListeFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.FunkprotokollQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.FunkprotokollQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.FunkprotokollQueryService);
        }
        return this.service;
    }
}
